export default "__VITE_ASSET__85eab84d__"